<template>
  <div class="project-video-crawler-settings-containaer">
    <div class="project-video-crawler-settings" v-if="!state.isLoading">
      <div class="project-video-crawler-settings__enable-crawler settings-container">
        <VideoCrawlerSettingsToggle
          :project="project"
          :initialCrawler="crawler"
          :onUpdateCrawler="onUpdateCrawler" />
      </div>
      <div class="divider" />
      <div class="project-video-crawler-settings__enable-crawler settings-container">
        <VideoCrawlerConfiguration
          :project="project"
          :initialCrawler="crawler"
          :onUpdateCrawler="onUpdateCrawler" />
      </div>
    </div>
  </div>
</template>

<script>
import { loadCrawlerSettings } from '@/project/api/';

import VideoCrawlerSettingsToggle from '@/project/videoCrawler/VideoCrawlerSettingsToggle.vue';
import VideoCrawlerConfiguration from '@/project/videoCrawler/VideoCrawlerConfiguration.vue';

export default {
  props: ['project'],
  components: {
    VideoCrawlerSettingsToggle,
    VideoCrawlerConfiguration,
  },
  data() {
    return {
      crawler: {},
      state: {
        isLoading: false,
      },
    };
  },
  created() {
    this.loadCrawlerSettings();
  },
  methods: {
    async loadCrawlerSettings() {
      this.state.isLoading = true;
      const response = await loadCrawlerSettings(this.project.projectId);
      this.crawler = response.data.crawler;
      this.state.isLoading = false;
    },
    onUpdateCrawler(crawler) {
      this.crawler = crawler;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/themes/components/page.scss';

.divider {
  height: 1px;
  margin: ($spacer * 2) $spacer;
  background-color: $gray-500;
  opacity: .5;
}
</style>
